import { useMutation, useQueryClient } from "@tanstack/vue-query";
import BucketLock from "@/services/bucket/bucket-lock";
import { UpdateBucketLockSettings } from "@/dtos/BucketLock.dto";

export function useUpdateBucketLockSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (settings: UpdateBucketLockSettings) => {
      const result = await BucketLock.updateBucketLockSettings(settings);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to update bucket lock settings");
      }
      return result.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bucketLockSettings"] });
      queryClient.invalidateQueries({ queryKey: ["bucketLockStatus"] });
    },
  });
}
